import { useContext, useEffect } from "react";

import { MonitoringEventTypeType } from "../shared/types/monitoring";

import { PubsubStatsCollectorContext } from "./PubsubStatsCollectorProvider";

import { useAppDispatch } from "store/index";
import { viewStateActions } from "store/slices/view";
import { useCreateMonitoringEvent } from "utils/hooks/use-create-monitoring-event";

const PUBSUB_STATS_COLLECTION_INTERVAL = 1000 * 60; // 1 minute

function MonitoringTasks() {
  const dispatch = useAppDispatch();
  const createMonitoringEvent = useCreateMonitoringEvent();
  const pubsubStatsCollector = useContext(PubsubStatsCollectorContext);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!pubsubStatsCollector) {
        return;
      }
      const stats = pubsubStatsCollector.getStats();
      if (!stats || !stats.pingRtt) {
        return;
      }

      // Update connection quality based on ping metrics
      let newConnectionQuality: "poor" | "good" | "fair";
      if (stats.pingRtt.isHigh) {
        newConnectionQuality = "poor";
      } else if (stats.pingRtt.isLow) {
        newConnectionQuality = "good";
      } else {
        newConnectionQuality = "fair";
      }

      dispatch(viewStateActions.setConnectionQuality(newConnectionQuality));

      createMonitoringEvent(MonitoringEventTypeType.PING_STATS, {
        pingRtt: {
          min: stats.pingRtt.min,
          max: stats.pingRtt.max,
          median: stats.pingRtt.median,
          isHigh: stats.pingRtt.isHigh,
          isLow: stats.pingRtt.isLow,
        },
      });
      pubsubStatsCollector.resetStats();
    }, PUBSUB_STATS_COLLECTION_INTERVAL);
    return () => clearInterval(interval);
  }, [dispatch, createMonitoringEvent, pubsubStatsCollector]);

  return null;
}

export { MonitoringTasks };
